import { config } from '../global/config';

const PIANO_ANALYTICS_LOADED_EVENT = 'piano-analytics-loaded';

let interceptorInitialized = false;
let interceptedSendEvent: typeof globalThis.pa.sendEvent | undefined;

const overrideSendEvent = () => {
  if (!globalThis.pa || globalThis.pa.sendEvent === interceptedSendEvent) {
    return;
  }

  const originalSendEvent = globalThis.pa.sendEvent;

  interceptedSendEvent = (eventName, data) => {
    const enrichedData = {
      site_env: config.environment,
      ...data,
    };
    originalSendEvent.call(globalThis.pa, eventName, enrichedData);
  };

  globalThis.pa.sendEvent = interceptedSendEvent;
};

export const initAnalyticsInterceptor = () => {
  overrideSendEvent();

  if (!interceptorInitialized) {
    globalThis.addEventListener(
      PIANO_ANALYTICS_LOADED_EVENT,
      overrideSendEvent,
    );
    interceptorInitialized = true;
  }
};
